import PropTypes from 'prop-types'
import { useEffect } from 'react'
import styled from 'styled-components/macro'

import ImgLoadTaken from 'legacy/assets/img/load_taken.png'
import { I18n } from 'legacy/components/I18n/i18n'
import { screen } from 'legacy/styles/screen'
import { analytics } from 'legacy/utils/analytics'

import { PreferredLaneToggle } from 'preferred-lanes/ui/PreferredLaneToggle'

import * as laneUtils from '../utils/laneUtils'

export const Wrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 16px;

  text-align: center;

  ${screen.md} {
    > :first-child {
      margin-top: -40px;
    }
  }
`

export const Message = styled.div`
  max-width: 400px;
  margin-top: 16px;

  font-size: 14px;
`

export const Lane = styled.div`
  margin: 20px 0;

  font-size: 12px;
`

const StyledPreferredLaneToggle = styled(PreferredLaneToggle)`
  align-self: stretch;

  ${screen.md} {
    align-self: auto;
  }
`

function LoadTaken(props) {
  const { lane, userIsLoggedIn } = props

  const laneDescription = lane && laneUtils.getPreferredLaneDescription(lane)

  useEffect(() => {
    analytics.track('Load Taken / View', { laneDescription })
  }, [laneDescription])

  return (
    <Wrapper>
      <img src={ImgLoadTaken} alt="Load taken" width="300px" height="200px" />
      <Message>{I18n.get('lb.loadTaken.message')}</Message>
      {userIsLoggedIn && lane && (
        <>
          <Lane>{laneDescription}</Lane>
          <StyledPreferredLaneToggle preferredLane={lane} />
        </>
      )}
    </Wrapper>
  )
}

LoadTaken.propTypes = {
  lane: PropTypes.shape({
    origin: PropTypes.shape({
      description: PropTypes.string,
    }),
    destination: PropTypes.shape({
      description: PropTypes.string,
    }),
    weekdays: PropTypes.arrayOf(PropTypes.string),
    equipment_types: PropTypes.arrayOf(PropTypes.string),
    starts_at: PropTypes.string,
    expires_at: PropTypes.string,
  }),
  userIsLoggedIn: PropTypes.bool,
}

LoadTaken.defaultProps = {
  lane: undefined,
  userIsLoggedIn: false,
}

export { LoadTaken }
